import EmailVerificationFormContainer from './EmailVerificationFormContainer';

export default EmailVerificationFormContainer;
